<template>
    <div class="townhall-upgrades">
        <div class="townhall-upgrades__buildings">
            
            <Price v-if="$store.state.blacksmith === false" v-bind="$store.getters['blacksmithCost']"/>
            <div class="townhall-upgrades__build">
                <div class="townhall-upgrades__item townhall-upgrades__item--blacksmith"
                    :class="{ 'townhall-upgrades__item--disabled': !$store.getters['hasResourcesForBlacksmith'] || $store.state.blacksmith }"
                    @click="$store.dispatch('addBlacksmith')"
                    title="Build the Blacksmith!">
                </div>
            </div>

            <Price v-bind="$store.getters['costForNewWorker']"/>
            <div class="townhall-upgrades__build">
                <div class="townhall-upgrades__item townhall-upgrades__item--gold"
                    :class="{ 'townhall-upgrades__item--disabled': !$store.getters['canHireWorker'] }"
                    @click="$store.dispatch('addGoldMiner')"
                    title="Hire Gold Miner!">
                </div>
                <div class="townhall-upgrades__item-count">{{ $store.state.goldWorkers.length }}</div>
            </div>

            <Price v-bind="$store.getters['costForNewWorker']"/>
            <div class="townhall-upgrades__build">
                <div class="townhall-upgrades__item townhall-upgrades__item--wood"
                    :class="{ 'townhall-upgrades__item--disabled': !$store.getters['canHireWorker'] }"
                    @click="$store.dispatch('addWoodWorker')"
                    title="Hire Wood Chopper!">
                </div>
                <div class="townhall-upgrades__item-count">{{ $store.state.woodWorkers.length }}</div>
            </div>

            <Price v-bind="$store.getters['costForNextFarm']"/>
            <div class="townhall-upgrades__build">
                <div class="townhall-upgrades__item townhall-upgrades__item--farm"
                    :class="{ 'townhall-upgrades__item--disabled': !$store.getters['hasResourcesForNextFarm'] }"
                    @click="$store.dispatch('addFarm')"
                    title="Build a new Farm!">
                </div>
                <div class="townhall-upgrades__item-count">{{ $store.state.farms }}</div>
            </div>
        </div>

        <ReturnButton />

        <div @click="deleteProgress" class="text-lg text-white font-bold p-3 m-3 bg-red-600 rounded-lg">
            DELETE PROGRESS
        </div>
    </div>
</template>

<script>
    import ReturnButton from "@/components/ReturnButton"
    import Price from "@/components/Price"

    export default {
        name: "TownhallUpgrades",
        components: {
            ReturnButton,
            Price
        },
        methods: {
            deleteProgress(){
                if (window.confirm("Are you sure you want to delete your progress?")) { 
                    this.$store.commit("turnTicksOff")
                    window.localStorage.removeItem('vuex')
                    window.location.href = "/";
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .townhall-upgrades {
        margin-top: 2rem;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        &__buildings {
            max-width: 13rem;
        }

        &__build {
            @apply flex justify-between;
            margin-bottom: 1rem;
        }

        &__item {
            @apply flex justify-start items-center;
            cursor: pointer;

            &--disabled {
                cursor: default;
                filter: saturate(0);
            }

            &--gold {
                animation: peon 1s steps(5) infinite;
                width: calc(30px * 2);
                height: calc(41px * 2);
                background: url('../assets/images/GoldWorkerSprite.png') top center;
                background-size: cover;
            }            

            &--wood {
                animation: peon 1.3s steps(5) infinite;
                width: calc(36px * 2);
                height: calc(41px * 2);
                background: url('../assets/images/WoodWorkerSprite.png') top center;
                background-size: cover;
            } 
            
            &--farm {
                width: 64px;
                height: 64px;
                background: url('../assets/images/farm_full.png') center center;
            }
            
            &--blacksmith {
                width: 96px;
                height: 92px;
                background: url('../assets/images/blacksmith.png') center center;
            }
        }

        &__item-count {
            margin-left: 1rem;
            @apply flex justify-start items-center text-lg font-bold;
        }
    }

    @keyframes peon {
        100% {
            background-position: 0 -410px;
        }
    }
</style>